import axios from "axios";
import Cookies from "js-cookie";
import { refreshAccessToken } from "./Request";
import {cacheTokensWithExpiration} from "./Utils";

/**
 * Creates an Axios instance with authentication credentials.
 */
export const withAuthCreds = () => {
    const API_URL = process.env.REACT_APP_API_URL;

    // Step 1: Create an instance of Axios with specific configuration
    const instance = axios.create({
        withCredentials: true,
        baseURL: API_URL,
        headers: {
            Authorization: `Bearer ${Cookies.get("accessToken")}`,
        },
    });

    // Step 2: Add an interceptor to the Axios instance
    instance.interceptors.response.use(OnFulfilled, OnFailed);

    function OnFulfilled(response) {
        // Step 2.1: If the response is successful, just return the response
        return response;
    }

    async function OnFailed(error) {
        // Step 2.2: If the response has an error and the status is 401
        const refreshToken = localStorage.getItem("refreshToken");
        if (error.response && error.response.status === 401) {
            // Step 2.2.1: Call the refreshAccessToken function to get a new access token
            const response = await refreshAccessToken(refreshToken);

            // Step 2.2.2: If the refresh is successful and the status is 200
            if (response && response.status === 200) {
                // Step 2.2.2.1: Update the Authorization header with the new access token
                cacheTokensWithExpiration(response);
                error.config.headers['Authorization'] = `Bearer ${Cookies.get("accessToken")}`;

                // Step 2.2.2.2: Retry the original request with the updated configuration
                return instance(error.config);
            }
        }
        // If the status is returning a locked state
        else if (error.response && error.response.status === 423) {
            localStorage.clear();
            Cookies.remove("accessToken");
            window.location.href = '/';
        }
        // Step 2.3: If the response has an error and the status is not 401, reject the Promise with the error
        return Promise.reject(error);
    }

    // Step 3: Return the Axios instance with the interceptor
    return instance;
};